<script context="module">
  import { create_multi_line_chart_dataset } from "./OrSixChartUtils.svelte";
  import { min_date } from "./UtilsBalkenProgress.svelte";

  var month_array_short = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

  var month_array_long = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  export const countries_by_salesteam = {
    "DACH+": ["Germany", "Austria", "Switzerland", "Netherlands", "Denmark", "Luxembourg", "Belgium"],
    USA: ["United States", "Canada"],
    "AUS/NZ": ["New Zealand"],
    UK: ["United Kingdom"],
    IE: ["Ireland"],
  };

  export const countries_code = {
    Germany: "DE",
    Austria: "AT",
    Switzerland: "CH",
    "United Kingdom": "UK",
    Ireland: "IE",
    "United States": "US",
    Netherlands: "NL",
    Denmark: "DK",
    "New Zealand": "NZ",
    Australia: "AU",
  };

  // for later usage from BigQuery
  // export const countries_by_salesteam = {
  //   'DACH+': ['57Germany', '12Austria', '43Switzerland', '165Netherlands', '59Denmark', '133Luxembourg', '20Belgium'],
  //   USA: ['233United States', '38Canada'],
  //   'AUS/NZ': ['170New Zealand'],
  //   UK: ['231United Kingdom'],
  //   IE: ['101Ireland'],
  // };

  // export const countries_code = {
  //   '57Germany': 'DE',
  //   '12Austria': 'AT',
  //   '43Switzerland': 'CH',
  //   '231United Kingdom': 'UK',
  //   '101Ireland': 'IE',
  //   '233United States': 'US',
  //   '165Netherlands': 'NL',
  //   '59Denmark': 'DK',
  //   '170New Zealand': 'NZ',
  //   '13Australia': 'AU',
  // };

  export function month_to_number(str) {
    let month_dict = {
      Jan: 0,
      Feb: 1,
      Mar: 2,
      Apr: 3,
      May: 4,
      Jun: 5,
      Jul: 6,
      Aug: 7,
      Sep: 8,
      Oct: 9,
      Nov: 10,
      Dec: 11,
    };

    return month_dict[str];
  }

  export function find_help_text_if_exists(helptexts, id) {
    if (helptexts) {
      for (var i = 0; i < helptexts.length; i += 1) {
        if (id == helptexts[i]["db_id"] && helptexts[i]["ignore"] == false) {
          return helptexts[i]["content"];
        }
      }
    } else {
      return false;
    }
  }

  export function object_values(dict) {
    const keys = Object.keys(dict).sort();
    const sortedValues = keys.map((key) => dict[key]);

    return sortedValues;
  }

  export function filter_for_new_client(
    res_partner_all,
    field_name,
    year_filter,
    country_selected,
    selected_team,
    x_team_country_dashboard,
    salesman_selected
  ) {
    let ret = [];

    res_partner_all.forEach((element) => {
      if (element[1]["id"] == 67322) {
        console.log("Gilbert August: ", element);
      }

      //filter country
      if (country_selected.length > 0) {
        if (!element[1]["country_id"]) {
          return;
        }
        if (element[1]["country_id"][1] != country_selected) {
          return;
        }
      }

      var sales_man_new_client = element[1]["user_id"][1];

      // if(sales_man_new_client == "Steffi Kreißl" && element[1]['x_studio_kunde_seit']){
      //     console.log("WANTED element: ", element[1])
      //     console.log("sales_man_new_client: ", sales_man_new_client)
      //   }

      if ("first_sales_person" in element[1]) {
        sales_man_new_client = element[1]["first_sales_person"];
        // if(element[1]['user_id'][1] == "Steffi Kreißl"){
        //   console.log("CHANGED: ", sales_man_new_client)
        // }
      }

      //filter sales persons
      var does_entry_belong_to_the_team = check_x_team_country_entry_does_entry_belong_to_team(
        true,
        sales_man_new_client,
        salesman_selected,
        x_team_country_dashboard,
        element[1]["country_id"][1],
        selected_team
      );

      if (!does_entry_belong_to_the_team) {
        return;
      }

      if (year_filter == "ALL") {
        ret.push(element[1]);
      } else {
        if (element[1][field_name]) {
          if (element[1][field_name].substring(0, 4) == year_filter) {
            ret.push(element[1]);
          }
        }
      }
    });

    return ret;
  }

  export function remove_dataimport_except_when_opportunity(crm_lead_all, lost_leads, lost_opportunities, archived) {
    var crm_lead_all_without_data_import = []; //source_id (1)
    var lost_leads_without_data_import = []; //x_source
    var lost_opportunities_without_data_import = []; //x_source
    var archived_without_data_import = []; //x_source

    crm_lead_all.forEach(function (element) {
      if (element[1]["source_id"][1] != "Data Import") {
        crm_lead_all_without_data_import.push(element);
      } else {
        if (element[1]["type"] == "opportunity") {
          if (element[1]["date_conversion"]) {
            element[1]["create_date"] = element[1]["date_conversion"];
          } else {
          }
          crm_lead_all_without_data_import.push(element);
        }
      }
    });

    lost_leads.forEach(function (element) {
      if (element["x_source"] != "Data Import") {
        lost_leads_without_data_import.push(element);
      } else {
      }
    });

    lost_opportunities.forEach(function (element) {
      if (element["x_source"] != "Data Import") {
        lost_opportunities_without_data_import.push(element);
      } else {
        if (element["x_type"] == "opportunity") {
          element["create_date"] = element["x_date_conversion"];
          lost_opportunities_without_data_import.push(element);
        }
      }
    });

    archived.forEach(function (element) {
      if (element[1]["x_source"] != "Data Import") {
        archived_without_data_import.push(element);
      } else {
        if (element[1]["x_type"] == "opportunity") {
          element[1]["create_date"] = element[1]["x_date_conversion"];
          archived_without_data_import.push(element);
        }
      }
    });

    return {
      crm_lead_all: crm_lead_all_without_data_import,
      lost_leads: lost_leads_without_data_import,
      lost_opportunities: lost_opportunities_without_data_import,
      archived: archived_without_data_import,
    };
  }

  export function set_customer_gauge(current_cust, current_month_goal, you_should_be_here, enough) {
    var opts_herdcoverage = {
      angle: -0.2, // The span of the gauge arc
      lineWidth: 0.4, // The line thickness
      radiusScale: 0.85, // Relative radius
      pointer: {
        length: 0.6, // // Relative to gauge radius
        strokeWidth: 0.035, // The thickness
        color: "#000000", // Fill color
      },
      renderTicks: {
        divisions: 10,
        divWidth: 0.7,
        divLength: 0.7,
        divColor: "#333333",
        subDivisions: 10,
        subLength: 0.5,
        subWidth: 0.3,
        subColor: "#666666",
      },
      limitMax: false, // If false, max value increases automatically if value > maxValue
      limitMin: false, // If true, the min value of the gauge will be fixed
      colorStart: "#6FADCF", // Colors
      colorStop: "#8FC0DA", // just experiment with them
      strokeColor: "#E0E0E0", // to see which ones work best for you
      generateGradient: true,
      highDpiSupport: true, // High resolution support
      staticZones: [],
    };
    let target = document.getElementById("gauge_canvas_new_cust_id"); // your canvas element
    if (!target) {
      return;
    }
    // console.log("target: ", target)

    you_should_be_here = Math.round(you_should_be_here);

    // console.log('you_should_be_here: ', you_should_be_here);
    // console.log('current_month_goal: ', current_month_goal);
    // console.log('current_cust: ', current_cust);

    let bereiche = [];
    var more_than_goal = false;

    if (current_cust > current_month_goal) {
      more_than_goal = true;

      let staticLabels = {
        font: "10px sans-serif", // Specifies font
        labels: [], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0, // Optional: Numerical precision. 0=round off.
      };

      var faktor = current_month_goal < 20 ? 5 : 10;

      if (current_month_goal > 100) {
        faktor = 25;
      }

      if (current_month_goal > 170) {
        faktor = 50;
      }

      if (current_month_goal > 500) {
        faktor = 125;
      }

      if (current_month_goal > 700) {
        faktor = 250;
      }

      if (current_month_goal > 1000) {
        faktor = 500;
      }

      // console.log('faktor: ', faktor);

      var extra_max = Math.ceil(current_cust / 100) * 100;

      if (faktor > 1000) {
        extra_max = Math.ceil(current_cust / faktor) * faktor;
      }

      console.log("extra_max1: ", extra_max);

      var x = 0;
      var count_x = 0;
      while (x <= extra_max) {
        staticLabels["labels"].push(x);
        x = x + faktor;
        count_x = count_x + 1;
      }
      staticLabels["labels"].push(x);

      opts_herdcoverage["renderTicks"]["divisions"] = count_x > 1 ? count_x - 1 : 1;

      opts_herdcoverage["staticLabels"] = staticLabels;

      console.log("hier1111");

      bereiche.push({ strokeStyle: "#03fcf4", min: 0, max: you_should_be_here });
      bereiche.push({ strokeStyle: enough ? "#268026" : "#990e05", min: you_should_be_here, max: current_month_goal });
      bereiche.push({ strokeStyle: "#22e610", min: current_month_goal, max: current_cust });
      bereiche.push({ strokeStyle: "#FFFFFF", min: current_cust, max: extra_max });

      // console.log('bereiche: ', bereiche);
      opts_herdcoverage["staticZones"] = bereiche;
      var gauge = new Gauge(target).setOptions(opts_herdcoverage); // create sexy gauge!
      gauge.maxValue = extra_max; // set max gauge value
      gauge.setMinValue(0); // Prefer setter over gauge.minValue = 0
      gauge.animationSpeed = 32; // set animation speed (32 is default value)
      gauge.set(current_cust); // set actual value
    } else {
      more_than_goal = false;

      let staticLabels = {
        font: "10px sans-serif", // Specifies font
        labels: [], // Print labels at these values
        color: "#000000", // Optional: Label text color
        fractionDigits: 0, // Optional: Numerical precision. 0=round off.
      };

      var faktor = current_month_goal < 20 ? 5 : 10;

      if (current_month_goal > 100) {
        faktor = 25;
      }

      if (current_month_goal > 170) {
        faktor = 50;
      }

      if (current_month_goal > 500) {
        faktor = 125;
      }

      if (current_month_goal > 700) {
        faktor = 250;
      }

      if (current_month_goal > 1000) {
        faktor = 500;
      }

      var extra_max = Math.ceil(current_month_goal / 100) * 100;

      if (faktor > 1000) {
        extra_max = Math.ceil(current_month_goal / faktor) * faktor;
      }

      var x = 0;
      var count_x = 0;
      while (x <= extra_max) {
        staticLabels["labels"].push(x);
        x = x + faktor;
        count_x = count_x + 1;
      }
      staticLabels["labels"].push(x);
      opts_herdcoverage["renderTicks"]["divisions"] = count_x > 1 ? count_x - 1 : 1;

      opts_herdcoverage["staticLabels"] = staticLabels;

      bereiche.push({ strokeStyle: "#03fcf4", min: 0, max: you_should_be_here });
      bereiche.push({ strokeStyle: enough ? "#268026" : "#990e05", min: you_should_be_here, max: current_month_goal });

      bereiche.push({
        strokeStyle: "#FFFFFF",
        min: current_month_goal,
        max: extra_max,
      });

      // console.log('bereiche: ', bereiche);
      opts_herdcoverage["staticZones"] = bereiche;
      var gauge = new Gauge(target).setOptions(opts_herdcoverage); // create sexy gauge!

      gauge.maxValue = extra_max; // set max gauge value
      gauge.setMinValue(0); // Prefer setter over gauge.minValue = 0
      gauge.animationSpeed = 32; // set animation speed (32 is default value)
      gauge.set(current_cust); // set actual value
    }
  }

  export function calc_months_from_selected_year(selected_year) {
    let ret_list = [];
    var from = 2020;
    var to = new Date().getFullYear();
    if (selected_year == "ALL") {
    } else {
      from = parseInt(selected_year);
      to = parseInt(selected_year);
    }
    var i = from;
    while (i <= to) {
      for (var m = 1; m <= 12; m++) {
        ret_list.push(i.toString() + "-" + (m < 10 ? "0" + m.toString() : m.toString()));
      }
      i += 1;
    }
    return ret_list;
  }

  export function all_sources(source_cat_dict) {
    var some_not_checked = false;
    source_cat_dict.forEach(function (s) {
      if (!s["checked"]) {
        some_not_checked = true;
      }
    });
    return !some_not_checked;
  }

  export function get_sales_goals(goals, months) {
    let ret_dict = {};

    months.forEach((m) => {
      ret_dict[m] = 0;
    });

    goals.forEach(function (element) {
      if (!element["start_date"]) {
        return;
      }
      if (!months.includes(element["start_date"].substring(0, 7))) {
        return;
      }

      if (element["x_studio_ziel"] && element["x_studio_ziel"].includes("SOLD_BOL_TARGET")) {
        return;
      }

      ret_dict[element["start_date"].substring(0, 7)] += element["target_goal"];
    });

    return ret_dict;
  }

  export function calc_new_customers_per_month_linechart_data(cust_goals_filtered, months, res_partner_filtered) {
    let ret_dict = {};
    let ret_dict_new_clients = {};
    let ret_clients = [];

    months.forEach((m) => {
      ret_dict[m] = 0;
      ret_dict_new_clients[m] = 0;
    });

    cust_goals_filtered.forEach((element) => {
      if (!element["start_date"] || !(element["start_date"].substring(0, 7) in ret_dict)) {
        return;
      }
      ret_dict[element["start_date"].substring(0, 7)] += element["target_goal"];
    });

    res_partner_filtered.forEach((element) => {
      var date_to_use = element["first_order_date"];

      if (!(element["company_type"] == "company")) {
        return;
      }

      if (element["x_studio_kunde_seit"]) {
        var date_obj_element_kunde_seit = new Date(element["x_studio_kunde_seit"]);
        if (element["first_order_date"]) {
          var date_obj_first_order_date = new Date(element["first_order_date"]);
          if (date_obj_element_kunde_seit < date_obj_first_order_date) {
            date_to_use = element["x_studio_kunde_seit"];
          }
        } else {
          date_to_use = element["x_studio_kunde_seit"];
        }
      }
      if (!date_to_use || !(date_to_use.substring(0, 7) in ret_dict_new_clients)) {
        return;
      }
      ret_dict_new_clients[date_to_use.substring(0, 7)] += 1;
      ret_clients.push(element);
    });

    months.forEach((m) => {
      if (ret_dict[m] == 0) {
        ret_dict[m] = null;
      }
      if (ret_dict_new_clients[m] == 0) {
        ret_dict_new_clients[m] = null;
      }
    });

    // return {'keys': Object.keys(ret_dict), 'target': Object.values(ret_dict), 'values': Object.values(ret_dict_new_clients)};

    return {
      targets: ret_dict,
      clients: ret_clients,
      values: ret_dict_new_clients,
      chart: create_multi_line_chart_dataset(
        Object.keys(ret_dict),
        [Object.values(ret_dict), Object.values(ret_dict_new_clients)],
        ["New Clients Target", "New Clients"],
        ["#a8e962", "#f2cd17"]
      ),
    };
  }

  export function calc_cust_gauge_values(new_cust_dict, new_cust_target_dict, year_filter) {
    var current_year = new Date().getFullYear();

    var act_sum = 0;
    var targ_sum = 0;

    var months = [];
    var you_should_be_here = 0;

    if (year_filter == "ALL" || year_filter == current_year) {
      months = [];
      for (var i = 0; i <= new Date().getMonth(); i++) {
        months.push(current_year.toString() + "-" + (i + 1 < 10 ? "0" + (i + 1).toString() : (i + 1).toString()));
      }

      months.forEach(function (m) {
        var m_i = parseInt(m.split("-")[1]);

        if (m in new_cust_dict) {
          act_sum += new_cust_dict[m];
        }
        if (m in new_cust_target_dict) {
          if (m_i == new Date().getMonth() + 1) {
            you_should_be_here += (new_cust_target_dict[m] * new Date().getDate()) / new Date(current_year, m_i - 1, 0).getDate();
          } else {
            you_should_be_here += new_cust_target_dict[m];
          }
        }
      });

      months = calc_months_from_selected_year(year_filter);
      months.forEach(function (m) {
        if (m in new_cust_target_dict) {
          targ_sum += new_cust_target_dict[m];
        }
      });
    } else {
      months = calc_months_from_selected_year(year_filter);
      months.forEach(function (m) {
        if (m in new_cust_dict) {
          act_sum += new_cust_dict[m];
        }
        if (m in new_cust_target_dict) {
          targ_sum += new_cust_target_dict[m];
        }
      });
      you_should_be_here = targ_sum;
    }

    return {
      current_cust: act_sum,
      current_month_goal: targ_sum,
      you_should_be_here: you_should_be_here,
      enough: act_sum >= you_should_be_here,
    };
  }

  export function source_text(source_cat_dict) {
    var some_not_checked = false;
    source_cat_dict.forEach(function (s) {
      if (!s["checked"]) {
        some_not_checked = true;
      }
    });

    if (some_not_checked) {
      return "Selected sources";
    }
    return "All sources";
  }

  export function number_to_month(str) {
    let month_dict = {
      0: "Jan",
      1: "Feb",
      2: "Mar",
      3: "Apr",
      4: "May",
      5: "Jun",
      6: "Jul",
      7: "Aug",
      8: "Sep",
      9: "Oct",
      10: "Nov",
      11: "Dec",
    };

    return month_dict[str];
  }

  export function get_list_of_dict_for_key(dict, k) {
    let ret_list = [];

    // console.log('dict: ', dict);

    for (const [key, c] of Object.entries(dict)) {
      ret_list.push(dict[key][k]);
    }

    // console.log('ret_list: ', ret_list);
    return ret_list;
  }

  export function calc_total_for_surces_and_campaigns_data_table_dict(source_value) {
    let all_values = {};

    for (const [campaign, leads_per_campaign_list_dict] of Object.entries(source_value)) {
      for (const [key, c] of Object.entries(leads_per_campaign_list_dict["results"])) {
        all_values[key] = 0;
      }
      //(Es reicht die Werte von einer Campaign zu holen)
      continue;
    }

    for (const [campaign, leads_per_campaign_list_dict] of Object.entries(source_value)) {
      for (const [key, c] of Object.entries(leads_per_campaign_list_dict["results"])) {
        all_values[key] += c;
      }
    }

    return all_values;
  }

  export function create_matrix(source_category, source, campaign, results, total) {
    return [
      " ",
      campaign,
      to_percentage(results["New_LEADS"], total["New_LEADS"]),
      results["New_LEADS"],
      results["New_OPP"],
      results["Open_Leads"],
      results["Archived_Leads"],
      results["Lost_Leads"],
      results["New_CUST"],
      results["Open"],
      results["Archived"],
      results["Lost"],
      results["ADV_New_Boli"] + results["ORG_New_Boli"] + results["EVT_New_Boli"] + results["SAL_New_Boli"],
      to_percentage(results["New_CUST"], total["New_CUST"]),
    ];
  }

  export function get_dict_of_sources_and_campains(
    crm_lead_all_filtered,
    lost_leads_filtered,
    lost_opportunities_filtered,
    archived_filtered,
    filter_country = false,
    filter_country_str = ""
  ) {
    let category_source_dict = {
      Advertising: {},
      Organic: {},
      Events: {},
      Sales: {},
    };

    crm_lead_all_filtered.forEach((element) => {
      var create_date = new Date(element["create_date"]);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var campaign = element["campaign_id"] ? element["campaign_id"][1] : "Keine Kampagne";
      var country = element["country"];
      var event_details = element["event_details_id"];

      if (filter_country && country != filter_country_str) {
        return;
      }

      if (!(source in category_source_dict[source_category])) {
        category_source_dict[source_category][source] = {};
      }

      if (source != "Event") {
        if (!(campaign in category_source_dict[source_category][source])) {
          category_source_dict[source_category][source][campaign] = {};
        }
        if (!("crm_lead_all_filtered" in category_source_dict[source_category][source][campaign])) {
          category_source_dict[source_category][source][campaign]["crm_lead_all_filtered"] = [];
        }
        category_source_dict[source_category][source][campaign]["crm_lead_all_filtered"].push(element);
      } else {
        if (!(event_details[1] in category_source_dict[source_category][source])) {
          category_source_dict[source_category][source][event_details[1]] = {};
        }
        if (!("crm_lead_all_filtered" in category_source_dict[source_category][source][event_details[1]])) {
          category_source_dict[source_category][source][event_details[1]]["crm_lead_all_filtered"] = [];
        }
        category_source_dict[source_category][source][event_details[1]]["crm_lead_all_filtered"].push(element);
      }
    });

    // console.log('crm_lead_all done');
    // console.log("lost_leads_filtered: ", lost_leads_filtered)
    lost_leads_filtered.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var campaign = element["campaign_id"] ? element["campaign_id"]["name"] : "Keine Kampagne";
      var country = element["country"];
      var event_details = element["x_eventdetails"];

      if (filter_country && country != filter_country_str) {
        return;
      }

      if (!(source in category_source_dict[source_category])) {
        category_source_dict[source_category][source] = {};
      }
      if (source != "Event") {
        if (!(campaign in category_source_dict[source_category][source])) {
          category_source_dict[source_category][source][campaign] = {};
        }
        if (!("lost_leads_filtered" in category_source_dict[source_category][source][campaign])) {
          category_source_dict[source_category][source][campaign]["lost_leads_filtered"] = [];
        }
        category_source_dict[source_category][source][campaign]["lost_leads_filtered"].push(element);
      } else {
        // console.log("event_details: ", event_details[1])
        if (!(event_details[1] in category_source_dict[source_category][source])) {
          category_source_dict[source_category][source][event_details[1]] = {};
        }
        if (!("lost_leads_filtered" in category_source_dict[source_category][source][event_details[1]])) {
          category_source_dict[source_category][source][event_details[1]]["lost_leads_filtered"] = [];
        }
        category_source_dict[source_category][source][event_details[1]]["lost_leads_filtered"].push(element);
      }
    });

    // console.log('lost_leads done');

    lost_opportunities_filtered.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var campaign = element["campaign_id"] ? element["campaign_id"]["name"] : "Keine Kampagne";
      var country = element["country"];
      var event_details = element["x_eventdetails"];

      if (filter_country && country != filter_country_str) {
        return;
      }

      if (!(source in category_source_dict[source_category])) {
        category_source_dict[source_category][source] = {};
      }
      if (source != "Event") {
        if (!(campaign in category_source_dict[source_category][source])) {
          category_source_dict[source_category][source][campaign] = {};
        }
        if (!("lost_opportunities_filtered" in category_source_dict[source_category][source][campaign])) {
          category_source_dict[source_category][source][campaign]["lost_opportunities_filtered"] = [];
        }
        category_source_dict[source_category][source][campaign]["lost_opportunities_filtered"].push(element);
      } else {
        // console.log("event_details: ", event_details[1])
        if (!(event_details[1] in category_source_dict[source_category][source])) {
          category_source_dict[source_category][source][event_details[1]] = {};
        }
        if (!("lost_opportunities_filtered" in category_source_dict[source_category][source][event_details[1]])) {
          category_source_dict[source_category][source][event_details[1]]["lost_opportunities_filtered"] = [];
        }
        category_source_dict[source_category][source][event_details[1]]["lost_opportunities_filtered"].push(element);
      }
    });

    // console.log('lost_opportunities done');

    archived_filtered.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var campaign = element["campaign_id"] ? element["campaign_id"]["name"] : "Keine Kampagne";
      var country = element["x_country_id"] ? element["x_country_id"][1] : false;
      var event_details = element["x_eventdetails"];

      if (filter_country && country != filter_country_str) {
        return;
      }

      if (!(source in category_source_dict[source_category])) {
        category_source_dict[source_category][source] = {};
      }

      if (source != "Event") {
        if (!(campaign in category_source_dict[source_category][source])) {
          category_source_dict[source_category][source][campaign] = {};
        }
        if (!("archived_filtered" in category_source_dict[source_category][source][campaign])) {
          category_source_dict[source_category][source][campaign]["archived_filtered"] = [];
        }
        category_source_dict[source_category][source][campaign]["archived_filtered"].push(element);
      } else {
        // console.log("event_details: ", event_details[1])
        if (!(event_details[1] in category_source_dict[source_category][source])) {
          category_source_dict[source_category][source][event_details[1]] = {};
        }
        if (!("archived_filtered" in category_source_dict[source_category][source][event_details[1]])) {
          category_source_dict[source_category][source][event_details[1]]["archived_filtered"] = [];
        }
        category_source_dict[source_category][source][event_details[1]]["archived_filtered"].push(element);
      }
    });

    return category_source_dict;
  }

  export function getLastDayOfMonth(date) {
    const lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0);
    lastDay.setHours(23, 59, 0, 0);
    return lastDay;
  }

  export function calculate_lead_flow_numbers(crm_lead_all, lost_leads, lost_opportunities, archived, date_start, date_end, all = false) {
    let new_leads = 0;
    let new_leads_normal = 0;
    let new_leads_lost_leads = 0;
    let new_leads_lost_opportunities = 0;
    let new_leads_archived = 0;

    let EVT = 0;
    let ORG = 0;
    let ADV = 0;
    let SAL = 0;

    let EVT_Lost_Leads = 0;
    let EVT_Archived_Leads = 0;
    let EVT_Open_Leads = 0;
    let EVT_New_OPP = 0;

    let ORG_Lost_Leads = 0;
    let ORG_Archived_Leads = 0;
    let ORG_Open_Leads = 0;
    let ORG_New_OPP = 0;

    let ADV_Lost_Leads = 0;
    let ADV_Archived_Leads = 0;
    let ADV_Open_Leads = 0;
    let ADV_New_OPP = 0;

    let SAL_Lost_Leads = 0;
    let SAL_Archived_Leads = 0;
    let SAL_Open_Leads = 0;
    let SAL_New_OPP = 0;

    let Lost_Leads = 0;
    let Archived_Leads = 0;
    let Open_Leads = 0;
    let New_OPP = 0;

    let EVT_New_OPP_Lost = 0;
    let ORG_New_OPP_Lost = 0;
    let ADV_New_OPP_Lost = 0;
    let SAL_New_OPP_Lost = 0;

    let EVT_New_OPP_Archived = 0;
    let ORG_New_OPP_Archived = 0;
    let ADV_New_OPP_Archived = 0;
    let SAL_New_OPP_Archived = 0;

    let EVT_New_OPP_Open = 0;
    let ORG_New_OPP_Open = 0;
    let ADV_New_OPP_Open = 0;
    let SAL_New_OPP_Open = 0;

    let Lost = 0;
    let Open = 0;
    let Archived = 0;

    let EVT_New_Customer = 0;
    let ORG_New_Customer = 0;
    let ADV_New_Customer = 0;
    let SAL_New_Customer = 0;

    let EVT_New_Boli = 0;
    let ORG_New_Boli = 0;
    let ADV_New_Boli = 0;
    let SAL_New_Boli = 0;

    let New_CUST = 0;

    let Lead_Aging_Median = 0;
    let Lead_Aging_List = [];

    let Opportunity_Aging_Median = 0;
    let Opportunity_Aging_List = [];

    let Lead_To_Customer_Aging_Median = 0;
    let Lead_To_Customer_Aging_List = [];

    let Lead_To_Customer_Conversion_Time_Median = 0;
    let Lead_To_Customer_Conversion_Time_List = [];

    let Lead_To_Opportunity_Conversion_Time_Median = 0;
    let Lead_To_Opportunity_Conversion_Time_List = [];

    let Opportunity_To_Customer_Conversion_Time_Median = 0;
    let Opportunity_To_Customer_Conversion_Time_List = [];

    crm_lead_all.forEach((element) => {
      var create_date = new Date(element["create_date"]);
      var source = element["source_id"][1];
      var source_category = element["source_category"];
      var type = element["type"];
      var is_won = element["is_won"];
      var sold_boli = element["sum_of_boli_sold_overall"];
      var date_conversion = element["date_conversion"];
      var date_closed = element["date_closed"];
      var partner__first_order_date = element["partner__first_order_date"] ? new Date(element["partner__first_order_date"]) : false;

      var last_stage_update = element["date_last_stage_update"];
      var stage_entry = element["stage_id"];
      var stage_name = false;
      if (stage_entry) {
        stage_name = stage_entry[1];
      }

      //Time LEAD -> CUST
      if ((type === "Opportunity" || type === "opportunity") && create_date && stage_name && last_stage_update && stage_name == "Won") {
        Lead_To_Customer_Conversion_Time_List.push(get_difference_in_days(new Date(create_date), new Date(last_stage_update)));
      }

      //Time LEAD -> OPP
      if ((type === "Opportunity" || type === "opportunity") && create_date) {
        if (date_conversion) {
          Lead_To_Opportunity_Conversion_Time_List.push(get_difference_in_days(new Date(create_date), new Date(date_conversion)));
        } else {
          Lead_To_Opportunity_Conversion_Time_List.push(0);
        }
      }

      //Time OPP -> CUST
      if ((type === "Opportunity" || type === "opportunity") && date_conversion && stage_name && last_stage_update && stage_name == "Won") {
        if (date_conversion) {
          Opportunity_To_Customer_Conversion_Time_List.push(get_difference_in_days(new Date(date_conversion), new Date(last_stage_update)));
        } else {
          Opportunity_To_Customer_Conversion_Time_List.push(get_difference_in_days(new Date(create_date), new Date(last_stage_update)));
        }
      }

      if (create_date >= date_start && create_date <= date_end) {
        new_leads += 1;
        new_leads_normal += 1;

        if (date_conversion) {
          Lead_Aging_List.push(get_difference_in_days(create_date, new Date(date_conversion)));
        } else {
          // console.log("date_end: ", date_end)
          Lead_Aging_List.push(get_difference_in_days(create_date, min_date(new Date(), date_end)));
        }

        if (
          (type === "Opportunity" || type === "opportunity") &&
          date_conversion &&
          stage_name &&
          last_stage_update &&
          stage_name == "Gewonnen"
        ) {
          Opportunity_Aging_List.push(get_difference_in_days(new Date(date_conversion), new Date(last_stage_update)));
        } else {
          if ((type === "Opportunity" || type === "opportunity") && date_conversion) {
            // console.log("date_end opp: ", date_end)
            Opportunity_Aging_List.push(get_difference_in_days(new Date(date_conversion), (new Date(), date_end)));
          }
        }

        if (is_won && partner__first_order_date) {
          // console.log("IS WON: ", element)
          // console.log("partner__first_order_date: ", partner__first_order_date)
          // console.log("create_date: create_date")
          // console.log("difference in days: ", get_difference_in_days(create_date, partner__first_order_date))

          if (!isNaN(get_difference_in_days(create_date, partner__first_order_date))) {
            Lead_To_Customer_Aging_List.push(get_difference_in_days(create_date, partner__first_order_date));
          }
        }

        if (source_category === "Events") {
          EVT += 1;
          if (type === "Lead" || type == "lead") {
            EVT_Open_Leads += 1;
          }
          if (type === "Opportunity" || type === "opportunity") {
            EVT_New_OPP += 1;
            EVT_New_Boli += sold_boli;
            if (is_won == false) {
              EVT_New_OPP_Open += 1;
            } else {
              EVT_New_Customer += 1;
            }
          }
        }
        if (source_category === "Organic") {
          ORG += 1;
          if (type === "Lead" || type == "lead") {
            ORG_Open_Leads += 1;
          }
          if (type === "Opportunity" || type === "opportunity") {
            ORG_New_OPP += 1;
            ORG_New_Boli += sold_boli;
            if (is_won == false) {
              ORG_New_OPP_Open += 1;
            } else {
              ORG_New_Customer += 1;
            }
          }
        }
        if (source_category === "Advertising") {
          ADV += 1;
          if (type === "Lead" || type == "lead") {
            ADV_Open_Leads += 1;
          }
          if (type === "Opportunity" || type === "opportunity") {
            ADV_New_OPP += 1;
            ADV_New_Boli += sold_boli;
            if (is_won == false) {
              ADV_New_OPP_Open += 1;
            } else {
              ADV_New_Customer += 1;
            }
          }
        }
        if (source_category === "Sales") {
          SAL += 1;
          if (type === "Lead" || type == "lead") {
            SAL_Open_Leads += 1;
          }
          if (type === "Opportunity" || type === "opportunity") {
            SAL_New_OPP += 1;
            SAL_New_Boli += sold_boli;
            if (is_won == false) {
              SAL_New_OPP_Open += 1;
            } else {
              SAL_New_Customer += 1;
            }
          }
        }
      }
    });

    // if (all) {
    //   console.log('Opportunity_Aging_List: ', Opportunity_Aging_List);
    // }

    // console.log('crm_lead_all done');

    lost_leads.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_closed = element["x_date_closed"];

      if (create_date >= date_start && create_date <= date_end) {
        new_leads += 1;
        new_leads_lost_leads += 1;

        Lead_Aging_List.push(get_difference_in_days(create_date, new Date(date_closed)));

        if (source == "event") {
          // console.log("if source event: ", element)
        }

        if (source_category === "Events") {
          EVT += 1;
          EVT_Lost_Leads += 1;
        }
        if (source_category === "Organic") {
          ORG += 1;
          ORG_Lost_Leads += 1;
        }
        if (source_category === "Advertising") {
          ADV += 1;
          ADV_Lost_Leads += 1;
        }
        if (source_category === "Sales") {
          SAL += 1;
          SAL_Lost_Leads += 1;
        }
      }
    });

    // console.log('lost_leads done');

    // console.log("lost_opportunities: ", lost_opportunities)

    lost_opportunities.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];
      var date_conversion = element["x_date_conversion"];
      var date_closed = element["x_date_closed"];

      if (create_date >= date_start && create_date <= date_end) {
        new_leads += 1;
        new_leads_lost_opportunities += 1;

        if (date_conversion) {
          Lead_Aging_List.push(get_difference_in_days(create_date, new Date(date_conversion)));
        } else {
          Lead_Aging_List.push(get_difference_in_days(create_date, new Date(date_closed)));
        }

        if (date_conversion && date_closed) {
          Opportunity_Aging_List.push(get_difference_in_days(new Date(date_conversion), new Date(date_closed)));
        } else {
          if (date_conversion) {
            Opportunity_Aging_List.push(get_difference_in_days(new Date(date_conversion), new Date()));
          }
        }

        if (source_category === "Events") {
          EVT += 1;
          EVT_New_OPP_Lost += 1;
        }
        if (source_category === "Organic") {
          ORG += 1;
          ORG_New_OPP_Lost += 1;
        }
        if (source_category === "Advertising") {
          ADV += 1;
          ADV_New_OPP_Lost += 1;
        }
        if (source_category === "Sales") {
          SAL += 1;
          SAL_New_OPP_Lost += 1;
        }
      }
    });

    // if (all) {
    //   console.log('Opportunity_Aging_List with Lost: ', Opportunity_Aging_List);
    // }
    // console.log('lost_opportunities done');

    archived.forEach((element) => {
      var create_date = new Date(element["x_date_creation"]);
      var source = element["x_source"];
      var source_category = element["source_category"];
      var type = element["x_type"];

      if (create_date >= date_start && create_date <= date_end) {
        new_leads += 1;
        new_leads_archived += 1;

        if (source_category === "Events") {
          EVT += 1;
          if (type === "lead" || type == "lead") {
            EVT_Archived_Leads += 1;
          }
          if (type === "opportunity" || type === "Opportunity") {
            EVT_New_OPP_Archived += 1;
            Archived += 1;
          }
        }
        if (source_category === "Organic") {
          ORG += 1;
          if (type === "lead" || type == "lead") {
            ORG_Archived_Leads += 1;
          }
          if (type === "opportunity" || type === "Opportunity") {
            ORG_New_OPP_Archived += 1;
            Archived += 1;
          }
        }
        if (source_category === "Advertising") {
          ADV += 1;
          if (type === "lead" || type == "lead") {
            ADV_Archived_Leads += 1;
          }
          if (type === "opportunity" || type === "Opportunity") {
            ADV_New_OPP_Archived += 1;
            Archived += 1;
          }
        }
        if (source_category === "Sales") {
          SAL += 1;
          if (type === "lead" || type == "lead") {
            SAL_Archived_Leads += 1;
          }
          if (type === "opportunity" || type === "Opportunity") {
            SAL_New_OPP_Archived += 1;
            Archived += 1;
          }
        }
      }
    });

    // console.log("date_start: ", date_start)
    // console.log("date_end: ", date_end)

    // console.log("Lead_To_Customer_Aging_List before sort: ", Lead_To_Customer_Aging_List)

    Lead_Aging_List.sort(function (a, b) {
      return a - b;
    });

    if (Lead_Aging_List.length > 0) {
      Lead_Aging_Median = Lead_Aging_List[Math.floor(Lead_Aging_List.length / 2)];
    } else {
      Lead_Aging_Median = 0;
    }

    Lead_To_Customer_Aging_List.sort(function (a, b) {
      return a - b;
    });

    if (Lead_To_Customer_Aging_List.length > 0) {
      Lead_To_Customer_Aging_Median = Lead_To_Customer_Aging_List[Math.floor(Lead_To_Customer_Aging_List.length / 2)];
    } else {
      Lead_To_Customer_Aging_Median = 0;
    }

    Opportunity_Aging_List.sort(function (a, b) {
      return a - b;
    });

    if (Opportunity_Aging_List.length > 0) {
      Opportunity_Aging_Median = Opportunity_Aging_List[Math.floor(Opportunity_Aging_List.length / 2)];
    } else {
      Opportunity_Aging_Median = 0;
    }

    Lead_To_Customer_Conversion_Time_List.sort(function (a, b) {
      return a - b;
    });

    if (Lead_To_Customer_Conversion_Time_List.length > 0) {
      Lead_To_Customer_Conversion_Time_Median =
        Lead_To_Customer_Conversion_Time_List[Math.floor(Lead_To_Customer_Conversion_Time_List.length / 2)];
    } else {
      Lead_To_Customer_Conversion_Time_Median = 0;
    }

    Lead_To_Opportunity_Conversion_Time_List.sort(function (a, b) {
      return a - b;
    });

    if (Lead_To_Opportunity_Conversion_Time_List.length > 0) {
      Lead_To_Opportunity_Conversion_Time_Median =
        Lead_To_Opportunity_Conversion_Time_List[Math.floor(Lead_To_Opportunity_Conversion_Time_List.length / 2)];
    } else {
      Lead_To_Opportunity_Conversion_Time_Median = 0;
    }

    Opportunity_To_Customer_Conversion_Time_List.sort(function (a, b) {
      return a - b;
    });

    if (Opportunity_To_Customer_Conversion_Time_List.length > 0) {
      Opportunity_To_Customer_Conversion_Time_Median =
        Opportunity_To_Customer_Conversion_Time_List[Math.floor(Opportunity_To_Customer_Conversion_Time_List.length / 2)];
    } else {
      Opportunity_To_Customer_Conversion_Time_Median = 0;
    }

    // console.log('Lead_Aging_List: ', Lead_Aging_List);

    Lost_Leads = EVT_Lost_Leads + ORG_Lost_Leads + ADV_Lost_Leads + SAL_Lost_Leads;
    Archived_Leads = EVT_Archived_Leads + ORG_Archived_Leads + ADV_Archived_Leads + SAL_Archived_Leads;
    Open_Leads = EVT_Open_Leads + ORG_Open_Leads + ADV_Open_Leads + SAL_Open_Leads;
    New_OPP =
      EVT_New_OPP +
      ORG_New_OPP +
      ADV_New_OPP +
      SAL_New_OPP +
      EVT_New_OPP_Lost +
      ORG_New_OPP_Lost +
      ADV_New_OPP_Lost +
      SAL_New_OPP_Lost +
      EVT_New_OPP_Archived +
      ORG_New_OPP_Archived +
      ADV_New_OPP_Archived +
      SAL_New_OPP_Archived;

    Lost = EVT_New_OPP_Lost + ORG_New_OPP_Lost + ADV_New_OPP_Lost + SAL_New_OPP_Lost;
    Open = EVT_New_OPP_Open + ORG_New_OPP_Open + ADV_New_OPP_Open + SAL_New_OPP_Open;

    New_CUST = EVT_New_Customer + ORG_New_Customer + ADV_New_Customer + SAL_New_Customer;

    // console.log('archived done');

    // console.log('new_leads_normal: ', new_leads_normal);
    // console.log('new_leads_lost_leads: ', new_leads_lost_leads);
    // console.log('new_leads_lost_opportunities: ', new_leads_lost_opportunities);
    // console.log('new_leads_archived: ', new_leads_archived);

    // console.log('Lost_Leads: ', Lost_Leads);
    // console.log('Archived_Leads: ', Archived_Leads);
    // console.log('Open_Leads: ', Open_Leads);
    // console.log('New_OPP: ', New_OPP);

    // console.log('EVT: ', EVT);
    // console.log('ORG: ', ORG);
    // console.log('ADV: ', ADV);

    // console.log('EVT_Archived_Leads: ', EVT_Archived_Leads);
    // console.log('ORG_Archived_Leads: ', ORG_Archived_Leads);
    // console.log('ADV_Archived_Leads: ', ADV_Archived_Leads);

    // console.log('new_leads: ', new_leads);

    // console.log('EVT_New_Customer: ', EVT_New_Customer);
    // console.log('ORG_New_Customer: ', ORG_New_Customer);
    // console.log('ADV_New_Customer: ', ADV_New_Customer);

    // console.log('date_start: ', date_start);
    // console.log('date_end: ', date_end);

    let ret_dict = {
      New_LEADS: new_leads,

      EVT: EVT,
      ORG: ORG,
      ADV: ADV,
      SAL: SAL,

      EVT_Lost_Leads: EVT_Lost_Leads,
      ORG_Lost_Leads: ORG_Lost_Leads,
      ADV_Lost_Leads: ADV_Lost_Leads,
      SAL_Lost_Leads: SAL_Lost_Leads,

      EVT_Archived_Leads: EVT_Archived_Leads,
      ORG_Archived_Leads: ORG_Archived_Leads,
      ADV_Archived_Leads: ADV_Archived_Leads,
      SAL_Archived_Leads: SAL_Archived_Leads,

      EVT_Open_Leads: EVT_Open_Leads,
      ORG_Open_Leads: ORG_Open_Leads,
      ADV_Open_Leads: ADV_Open_Leads,
      SAL_Open_Leads: SAL_Open_Leads,

      Lost_Leads: Lost_Leads,
      Archived_Leads: Archived_Leads,
      Open_Leads: Open_Leads,
      New_OPP: New_OPP,

      EVT_New_OPP: EVT_New_OPP + EVT_New_OPP_Lost + EVT_New_OPP_Archived,
      ORG_New_OPP: ORG_New_OPP + ORG_New_OPP_Lost + ORG_New_OPP_Archived,
      ADV_New_OPP: ADV_New_OPP + ADV_New_OPP_Lost + ADV_New_OPP_Archived,
      SAL_New_OPP: SAL_New_OPP + SAL_New_OPP_Lost + SAL_New_OPP_Archived,

      New_OPP: New_OPP,

      EVT_New_OPP_Lost: EVT_New_OPP_Lost,
      ORG_New_OPP_Lost: ORG_New_OPP_Lost,
      ADV_New_OPP_Lost: ADV_New_OPP_Lost,
      SAL_New_OPP_Lost: SAL_New_OPP_Lost,

      Lost: Lost,
      Open: Open,
      New_CUST: New_CUST,
      Archived: Archived,

      EVT_New_OPP_Open: EVT_New_OPP_Open,
      ORG_New_OPP_Open: ORG_New_OPP_Open,
      ADV_New_OPP_Open: ADV_New_OPP_Open,
      SAL_New_OPP_Open: SAL_New_OPP_Open,

      EVT_New_OPP_Archived: EVT_New_OPP_Archived,
      ORG_New_OPP_Archived: ORG_New_OPP_Archived,
      ADV_New_OPP_Archived: ADV_New_OPP_Archived,
      SAL_New_OPP_Archived: SAL_New_OPP_Archived,

      EVT_New_Customer: EVT_New_Customer,
      ORG_New_Customer: ORG_New_Customer,
      ADV_New_Customer: ADV_New_Customer,
      SAL_New_Customer: SAL_New_Customer,

      EVT_New_Boli: EVT_New_Boli,
      ORG_New_Boli: ORG_New_Boli,
      ADV_New_Boli: ADV_New_Boli,
      SAL_New_Boli: SAL_New_Boli,

      Lead_Aging_Median: Lead_Aging_Median,
      Opportunity_Aging_Median: Opportunity_Aging_Median,
      Lead_To_Customer_Aging_Median: Lead_To_Customer_Aging_Median,

      Lead_To_Customer_Conversion_Time_Median: Lead_To_Customer_Conversion_Time_Median,
      Lead_To_Opportunity_Conversion_Time_Median: Lead_To_Opportunity_Conversion_Time_Median,
      Opportunity_To_Customer_Conversion_Time_Median: Opportunity_To_Customer_Conversion_Time_Median,

      Lead_To_Customer_Conversion_Time_List: Lead_To_Customer_Conversion_Time_List,
      Lead_To_Opportunity_Conversion_Time_List: Lead_To_Opportunity_Conversion_Time_List,
      Opportunity_To_Customer_Conversion_Time_List: Opportunity_To_Customer_Conversion_Time_List,
    };

    // console.log("ret_dict: ", ret_dict)

    return ret_dict;
  }

  export function to_percentage(a, b) {
    if (b == 0) {
      return "0%";
    }
    return ((a * 100) / b).toFixed(0) + "%";
  }

  export function get_table_data_no_split(flow_numbers_dict) {
    return {
      columns: [
        {
          value: "",
          border_col_top: "#FFFFFF",
          border_col_sides: false,
          background_color: "#FFFFFF",
          extra_class: "width: 30%",
          text_color: "#262626",
        },
        {
          value: "% of New Leads",
          border_col_top: "#40c4f4",
          border_col_sides: "#40c4f4",
          background_color: "#FFFFFF",
          extra_class: "",
          text_color: "#40c4f4",
        },
        {
          value: "New LEADS",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#d6dce4",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "New OPP",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#d6dce4",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "Open Leads",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#FFFFFF",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "Archived Leads",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#FFFFFF",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "Lost Leads",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#FFFFFF",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "New CUST",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#d6dce4",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "Open OPPs",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#FFFFFF",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "Archived OPPs",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#FFFFFF",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "Lost OPPs",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#FFFFFF",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "Sold BOLUSES",
          border_col_top: "#96a0ad",
          border_col_sides: false,
          background_color: "#d6dce4",
          extra_class: "",
          text_color: "#262626",
        },
        {
          value: "% of New CUST",
          border_col_top: "#40c4f4",
          border_col_sides: "#40c4f4",
          background_color: "#FFFFFF",
          extra_class: "",
          text_color: "#40c4f4",
        },
      ],
      values: [
        [
          {
            value: "Total",
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: "width: 30%",
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: "100%",
            border_col_top: "#44546a",
            border_col_sides: "#40c4f4",
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#40c4f4",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["New_LEADS"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["New_OPP"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["Open_Leads"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["Archived_Leads"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["Lost_Leads"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["New_CUST"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["Open"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["Archived"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: flow_numbers_dict["Lost"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value:
              flow_numbers_dict["ADV_New_Boli"] +
              flow_numbers_dict["EVT_New_Boli"] +
              flow_numbers_dict["ORG_New_Boli"] +
              flow_numbers_dict["SAL_New_Boli"],
            border_col_top: "#44546a",
            border_col_sides: false,
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#262626",
            border_bottom: "#44546a",
          },
          {
            value: "100%",
            border_col_top: "#44546a",
            border_col_sides: "#40c4f4",
            background_color: "#d6dce4",
            extra_class: false,
            text_color: "#40c4f4",
            border_bottom: "#44546a",
          },
        ],
      ],
    };
  }

  export function get_flow_chart_data(flow_numbers_dict, screen_width) {
    // console.log('flow_numbers_dict: ', flow_numbers_dict);

    return {
      nodes: [
        {
          id: "Leads",
          absolute: flow_numbers_dict["New_LEADS"],
          percentage: "",
          text_color: "#FFFFFF",
          extra: "New LEADS",
          color: "#2e4756",
          "stroke-width": 0.3333,
          stroke: "#FFFFFF",
        },

        //Ebene 1:

        {
          id: "EVT",
          extra: "EVT",
          absolute: flow_numbers_dict["EVT"],
          percentage: to_percentage(flow_numbers_dict["EVT"], flow_numbers_dict["New_LEADS"]),
          text_color: "#FFFFFF",
          color: "#f9b000",
          "stroke-width": 0.3333,
          stroke: "#FFFFFF",
          shift_left: "Leads" /*shift_down: 7,*/,
        },
        {
          id: "ORG",
          extra: "ORG",
          absolute: flow_numbers_dict["ORG"],
          percentage: to_percentage(flow_numbers_dict["ORG"], flow_numbers_dict["New_LEADS"]),
          text_color: "#FFFFFF",
          color: "#c7164e",
          "stroke-width": 0.3333,
          stroke: "#FFFFFF",
          shift_left: "Leads" /*shift_down: -3,*/,
        },
        {
          id: "ADV",
          extra: "ADV",
          absolute: flow_numbers_dict["ADV"],
          percentage: to_percentage(flow_numbers_dict["ADV"], flow_numbers_dict["New_LEADS"]),
          text_color: "#FFFFFF",
          color: "#67b7d1",
          "stroke-width": 0.3333,
          stroke: "#FFFFFF",
          shift_left: "Leads" /*shift_down: -13,*/,
        },
        {
          id: "SAL",
          extra: "SAL",
          absolute: flow_numbers_dict["SAL"],
          percentage: to_percentage(flow_numbers_dict["SAL"], flow_numbers_dict["New_LEADS"]),
          text_color: "#FFFFFF",
          color: "#4D5D8D",
          "stroke-width": 0.3333,
          stroke: "#FFFFFF",
          shift_left: "Leads" /*shift_down: -13,*/,
        },

        //Ebene 2:
        {
          id: "Lost Leads",
          extra: "Lost Leads",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Lost_Leads"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: screen_width / 10,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "Archived Leads",
          extra: "Ar chi ved Leads",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Archived_Leads"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: screen_width / 10,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "Open Leads",
          extra: "Open Leads",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Open_Leads"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: screen_width / 10,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "OPP",
          extra: "OPP",
          text_color: "#FFFFFF",
          absolute: flow_numbers_dict["New_OPP"],
          percentage: "",
          color: "#2e4756",
          shift_x: screen_width / 10,
          "stroke-width": 0.3333,
          stroke: "#FFFFFF",
        },

        //Ebene 3:
        {
          id: "OPP_1",
          extra: " ",
          absolute: flow_numbers_dict["EVT_New_OPP"],
          percentage: to_percentage(flow_numbers_dict["EVT_New_OPP"], flow_numbers_dict["New_OPP"]),
          text_color: "#FFFFFF",
          color: "#f9b000",
          "stroke-width": 0.3333,
          shift_left: "OPP",
          stroke: "#FFFFFF",
        },
        {
          id: "OPP_2",
          extra: " ",
          absolute: flow_numbers_dict["ORG_New_OPP"],
          percentage: to_percentage(flow_numbers_dict["ORG_New_OPP"], flow_numbers_dict["New_OPP"]),
          text_color: "#FFFFFF",
          color: "#c7164e",
          "stroke-width": 0.3333,
          shift_left: "OPP",
          stroke: "#FFFFFF",
        },
        {
          id: "OPP_3",
          extra: " ",
          absolute: flow_numbers_dict["ADV_New_OPP"],
          percentage: to_percentage(flow_numbers_dict["ADV_New_OPP"], flow_numbers_dict["New_OPP"]),
          text_color: "#FFFFFF",
          color: "#67b7d1",
          "stroke-width": 0.3333,
          shift_left: "OPP",
          stroke: "#FFFFFF",
        },
        {
          id: "OPP_4",
          extra: " ",
          absolute: flow_numbers_dict["SAL_New_OPP"],
          percentage: to_percentage(flow_numbers_dict["SAL_New_OPP"], flow_numbers_dict["New_OPP"]),
          text_color: "#FFFFFF",
          color: "#4D5D8D",
          "stroke-width": 0.3333,
          shift_left: "OPP",
          stroke: "#FFFFFF",
        },

        //Ebene 4:
        {
          id: "Lost",
          extra: "Lost",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Lost"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: screen_width / 5,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "Open",
          extra: "Open",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Open"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: screen_width / 5,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "New CUST",
          extra: "New CUST",
          text_color: "#FFFFFF",
          absolute: flow_numbers_dict["New_CUST"],
          percentage: "",
          color: "#2e4756",
          shift_x: screen_width / 5,
          "stroke-width": 0.3333,
          stroke: "#FFFFFF",
        },
        {
          id: "Archived",
          extra: "Archived",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Archived"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: screen_width / 5,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },

        //Ebene 5:
        {
          id: "New CUST1",
          extra: " ",
          absolute: flow_numbers_dict["EVT_New_Customer"],
          percentage: to_percentage(flow_numbers_dict["EVT_New_Customer"], flow_numbers_dict["New_CUST"]),
          text_color: "#FFFFFF",
          color: "#f9b000",
          "stroke-width": 0.3333,
          shift_left: "New CUST",
          stroke: "#FFFFFF",
        },
        {
          id: "New CUST2",
          extra: " ",
          absolute: flow_numbers_dict["ORG_New_Customer"],
          percentage: to_percentage(flow_numbers_dict["ORG_New_Customer"], flow_numbers_dict["New_CUST"]),
          text_color: "#FFFFFF",
          color: "#c7164e",
          "stroke-width": 0.3333,
          shift_left: "New CUST",
          stroke: "#FFFFFF",
        },
        {
          id: "New CUST3",
          extra: " ",
          absolute: flow_numbers_dict["ADV_New_Customer"],
          percentage: to_percentage(flow_numbers_dict["ADV_New_Customer"], flow_numbers_dict["New_CUST"]),
          text_color: "#FFFFFF",
          color: "#67b7d1",
          "stroke-width": 0.3333,
          shift_left: "New CUST",
          stroke: "#FFFFFF",
        },
        {
          id: "New CUST4",
          extra: " ",
          absolute: flow_numbers_dict["SAL_New_Customer"],
          percentage: to_percentage(flow_numbers_dict["SAL_New_Customer"], flow_numbers_dict["New_CUST"]),
          text_color: "#FFFFFF",
          color: "#4D5D8D",
          "stroke-width": 0.3333,
          shift_left: "New CUST",
          stroke: "#FFFFFF",
        },

        // EBENE 6:
        {
          id: "Fakenode",
          extra: "",
          text_color: "#FFFFFF",
          absolute: 0,
          percentage: "",
          color: "#FFFFFF",
          "stroke-width": 0.3333,
          shift_x: 0,
          border_color: "#2e4756",
        },
        {
          id: "New Boli EVT",
          extra: "Sold BOLUSES EVT",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["EVT_New_Boli"],
          percentage: "",
          color: "#ffffff",
          "stroke-width": 0.5,
          shift_x: -20,
          stroke: "#f9b000",
        },
        {
          id: "New Boli ORG",
          extra: "Sold BOLUSES ORG",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["ORG_New_Boli"],
          percentage: "",
          color: "#ffffff",
          "stroke-width": 0.5,
          shift_x: -20,
          stroke: "#c7164e",
        },
        {
          id: "New Boli ADV",
          extra: "Sold BOLUSES ADV",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["ADV_New_Boli"],
          percentage: "",
          color: "#ffffff",
          "stroke-width": 0.5,
          shift_x: -20,
          stroke: "#67b7d1",
        },
        {
          id: "New Boli SAL",
          extra: "Sold BOLUSES SAL",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["SAL_New_Boli"],
          percentage: "",
          color: "#ffffff",
          "stroke-width": 0.5,
          shift_x: -20,
          stroke: "#4D5D8D",
        },
      ],
      links: [
        //Ebene 1:
        { source: "Leads", target: "EVT", value: flow_numbers_dict["EVT"], show_link: false, show_link_text: false },
        { source: "Leads", target: "ORG", value: flow_numbers_dict["ORG"], show_link: false, show_link_text: false },
        { source: "Leads", target: "ADV", value: flow_numbers_dict["ADV"], show_link: false, show_link_text: false },
        { source: "Leads", target: "SAL", value: flow_numbers_dict["SAL"], show_link: false, show_link_text: false },

        //Ebene 2:

        {
          source: "EVT",
          target: "Lost Leads",
          value: flow_numbers_dict["EVT_Lost_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#f9b000",
        },
        {
          source: "EVT",
          target: "Archived Leads",
          value: flow_numbers_dict["EVT_Archived_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#f9b000",
        },
        {
          source: "EVT",
          target: "Open Leads",
          value: flow_numbers_dict["EVT_Open_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#f9b000",
        },
        { source: "EVT", target: "OPP", value: flow_numbers_dict["EVT_New_OPP"], show_link: true, show_link_text: false, color: "#f9b000" },
        {
          source: "ORG",
          target: "Lost Leads",
          value: flow_numbers_dict["ORG_Lost_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#c7164e",
        },
        {
          source: "ORG",
          target: "Archived Leads",
          value: flow_numbers_dict["ORG_Archived_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#c7164e",
        },
        {
          source: "ORG",
          target: "Open Leads",
          value: flow_numbers_dict["ORG_Open_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#c7164e",
        },
        { source: "ORG", target: "OPP", value: flow_numbers_dict["ORG_New_OPP"], show_link: true, show_link_text: false, color: "#c7164e" },
        {
          source: "ADV",
          target: "Lost Leads",
          value: flow_numbers_dict["ADV_Lost_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#67b7d1",
        },
        {
          source: "ADV",
          target: "Archived Leads",
          value: flow_numbers_dict["ADV_Archived_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#67b7d1",
        },
        {
          source: "ADV",
          target: "Open Leads",
          value: flow_numbers_dict["ADV_Open_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#67b7d1",
        },
        { source: "ADV", target: "OPP", value: flow_numbers_dict["ADV_New_OPP"], show_link: true, show_link_text: false, color: "#67b7d1" },

        {
          source: "SAL",
          target: "Lost Leads",
          value: flow_numbers_dict["SAL_Lost_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#4D5D8D",
        },
        {
          source: "SAL",
          target: "Archived Leads",
          value: flow_numbers_dict["SAL_Archived_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#4D5D8D",
        },
        {
          source: "SAL",
          target: "Open Leads",
          value: flow_numbers_dict["SAL_Open_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#4D5D8D",
        },
        { source: "SAL", target: "OPP", value: flow_numbers_dict["SAL_New_OPP"], show_link: true, show_link_text: false, color: "#4D5D8D" },

        //Ebene 3:
        {
          source: "OPP",
          target: "OPP_1",
          value: flow_numbers_dict["EVT_New_OPP"],
          show_link: false,
          show_link_text: true,
          color: "#f9b000",
        },
        {
          source: "OPP",
          target: "OPP_2",
          value: flow_numbers_dict["ORG_New_OPP"],
          show_link: false,
          show_link_text: true,
          color: "#c7164e",
        },
        {
          source: "OPP",
          target: "OPP_3",
          value: flow_numbers_dict["ADV_New_OPP"],
          show_link: false,
          show_link_text: true,
          color: "#67b7d1",
        },
        {
          source: "OPP",
          target: "OPP_4",
          value: flow_numbers_dict["SAL_New_OPP"],
          show_link: false,
          show_link_text: true,
          color: "#4D5D8D",
        },

        //Ebene 4:
        {
          source: "OPP_1",
          target: "Lost",
          value: flow_numbers_dict["EVT_New_OPP_Lost"],
          show_link: true,
          show_link_text: false,
          color: "#f9b000",
        },
        {
          source: "OPP_2",
          target: "Lost",
          value: flow_numbers_dict["ORG_New_OPP_Lost"],
          show_link: true,
          show_link_text: false,
          color: "#c7164e",
        },
        {
          source: "OPP_3",
          target: "Lost",
          value: flow_numbers_dict["ADV_New_OPP_Lost"],
          show_link: true,
          show_link_text: false,
          color: "#67b7d1",
        },
        {
          source: "OPP_4",
          target: "Lost",
          value: flow_numbers_dict["SAL_New_OPP_Lost"],
          show_link: true,
          show_link_text: false,
          color: "#4D5D8D",
        },
        {
          source: "OPP_1",
          target: "Open",
          value: flow_numbers_dict["EVT_New_OPP_Open"],
          show_link: true,
          show_link_text: false,
          color: "#f9b000",
        },
        {
          source: "OPP_2",
          target: "Open",
          value: flow_numbers_dict["ORG_New_OPP_Open"],
          show_link: true,
          show_link_text: false,
          color: "#c7164e",
        },
        {
          source: "OPP_3",
          target: "Open",
          value: flow_numbers_dict["ADV_New_OPP_Open"],
          show_link: true,
          show_link_text: false,
          color: "#67b7d1",
        },
        {
          source: "OPP_4",
          target: "Open",
          value: flow_numbers_dict["SAL_New_OPP_Open"],
          show_link: true,
          show_link_text: false,
          color: "#4D5D8D",
        },

        {
          source: "OPP_1",
          target: "New CUST",
          value: flow_numbers_dict["EVT_New_Customer"],
          show_link: true,
          show_link_text: false,
          color: "#f9b000",
        },
        {
          source: "OPP_2",
          target: "New CUST",
          value: flow_numbers_dict["ORG_New_Customer"],
          show_link: true,
          show_link_text: false,
          color: "#c7164e",
        },
        {
          source: "OPP_3",
          target: "New CUST",
          value: flow_numbers_dict["ADV_New_Customer"],
          show_link: true,
          show_link_text: false,
          color: "#67b7d1",
        },
        {
          source: "OPP_4",
          target: "New CUST",
          value: flow_numbers_dict["SAL_New_Customer"],
          show_link: true,
          show_link_text: false,
          color: "#4D5D8D",
        },

        {
          source: "OPP_1",
          target: "Archived",
          value: flow_numbers_dict["EVT_New_OPP_Archived"],
          show_link: true,
          show_link_text: false,
          color: "#f9b000",
        },
        {
          source: "OPP_2",
          target: "Archived",
          value: flow_numbers_dict["ORG_New_OPP_Archived"],
          show_link: true,
          show_link_text: false,
          color: "#c7164e",
        },
        {
          source: "OPP_3",
          target: "Archived",
          value: flow_numbers_dict["ADV_New_OPP_Archived"],
          show_link: true,
          show_link_text: false,
          color: "#67b7d1",
        },
        {
          source: "OPP_4",
          target: "Archived",
          value: flow_numbers_dict["SAL_New_OPP_Archived"],
          show_link: true,
          show_link_text: false,
          color: "#4D5D8D",
        },

        //Ebene 5:
        {
          source: "New CUST",
          target: "New CUST1",
          value: flow_numbers_dict["EVT_New_Customer"],
          show_link: false,
          show_link_text: false,
          color: "#ffffff",
        },
        {
          source: "New CUST",
          target: "New CUST2",
          value: flow_numbers_dict["ORG_New_Customer"],
          show_link: false,
          show_link_text: false,
          color: "#ffffff",
        },
        {
          source: "New CUST",
          target: "New CUST3",
          value: flow_numbers_dict["ADV_New_Customer"],
          show_link: false,
          show_link_text: false,
          color: "#ffffff",
        },
        {
          source: "New CUST",
          target: "New CUST4",
          value: flow_numbers_dict["SAL_New_Customer"],
          show_link: false,
          show_link_text: false,
          color: "#ffffff",
        },

        //Ebene zwischen 5 und 6:
        {
          source: "New CUST3",
          target: "Fakenode",
          value: 0,
          show_link: false,
          show_link_text: false,
          color: "#f9b000",
        },

        //Ebene 6:
        {
          source: "Fakenode",
          target: "New Boli EVT",
          value: transform_boli_size_in_relation(
            flow_numbers_dict["New_LEADS"],
            flow_numbers_dict["EVT_New_Boli"] +
              flow_numbers_dict["ORG_New_Boli"] +
              flow_numbers_dict["ADV_New_Boli"] +
              flow_numbers_dict["SAL_New_Boli"],
            flow_numbers_dict["EVT_New_Boli"]
          ),
          show_link: false,
          show_link_text: false,
          color: "#f9b000",
        },
        {
          source: "Fakenode",
          target: "New Boli ORG",
          value: transform_boli_size_in_relation(
            flow_numbers_dict["New_LEADS"],
            flow_numbers_dict["EVT_New_Boli"] +
              flow_numbers_dict["ORG_New_Boli"] +
              flow_numbers_dict["ADV_New_Boli"] +
              flow_numbers_dict["SAL_New_Boli"],
            flow_numbers_dict["ORG_New_Boli"]
          ),
          show_link: false,
          show_link_text: false,
          color: "#c7164e",
        },
        {
          source: "Fakenode",
          target: "New Boli ADV",
          value: transform_boli_size_in_relation(
            flow_numbers_dict["New_LEADS"],
            flow_numbers_dict["EVT_New_Boli"] +
              flow_numbers_dict["ORG_New_Boli"] +
              flow_numbers_dict["ADV_New_Boli"] +
              flow_numbers_dict["SAL_New_Boli"],
            flow_numbers_dict["ADV_New_Boli"]
          ),
          show_link: false,
          show_link_text: false,
          color: "#67b7d1",
        },

        {
          source: "Fakenode",
          target: "New Boli SAL",
          value: transform_boli_size_in_relation(
            flow_numbers_dict["New_LEADS"],
            flow_numbers_dict["EVT_New_Boli"] +
              flow_numbers_dict["ORG_New_Boli"] +
              flow_numbers_dict["ADV_New_Boli"] +
              flow_numbers_dict["SAL_New_Boli"],
            flow_numbers_dict["SAL_New_Boli"]
          ),
          show_link: false,
          show_link_text: false,
          color: "#4D5D8D",
        },
      ],
    };
  }

  function transform_boli_size_in_relation(new_leads, sold_boli_overall, sold_boli_cat) {
    if (sold_boli_cat == 0 || sold_boli_overall == 0 || new_leads == 0) {
      return 0;
    }

    return (sold_boli_cat / sold_boli_overall) * new_leads;
  }

  export function get_flow_chart_data_without_split(flow_numbers_dict, screen_width) {
    console.log("flow_numbers_dict: ", flow_numbers_dict);

    return {
      nodes: [
        {
          id: "Leads",
          absolute: flow_numbers_dict["New_LEADS"],
          percentage: "",
          text_color: "#FFFFFF",
          extra: "New LEADS",
          color: "#2e4756",
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },

        //Ebene 1:

        //Ebene 2:
        {
          id: "Lost Leads",
          extra: "Lost Leads",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Lost_Leads"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: -30,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "Archived Leads",
          extra: "Ar chi ved Leads",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Archived_Leads"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: -30,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "Open Leads",
          extra: "Open Leads",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Open_Leads"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: -30,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "OPP",
          extra: "OPP",
          text_color: "#FFFFFF",
          absolute: flow_numbers_dict["New_OPP"],
          percentage: "",
          color: "#2e4756",
          shift_x: -30,
          "stroke-width": 0.3333,
        },

        //Ebene 4:
        {
          id: "Lost",
          extra: "Lost",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Lost"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: -30,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "Open",
          extra: "Open",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Open"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: -30,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "New CUST",
          extra: "New CUST",
          text_color: "#FFFFFF",
          absolute: flow_numbers_dict["New_CUST"],
          percentage: "",
          color: "#2e4756",
          shift_x: -30,
          "stroke-width": 0.3333,
        },
        {
          id: "Archived",
          extra: "Archived",
          text_color: "#2e4756",
          absolute: flow_numbers_dict["Archived"],
          percentage: "",
          color: "#f3f4f4",
          shift_x: -30,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
        {
          id: "New Boli",
          extra: "Boli",
          text_color: "#FFFFFF",
          absolute:
            flow_numbers_dict["EVT_New_Boli"] +
            flow_numbers_dict["ORG_New_Boli"] +
            flow_numbers_dict["ADV_New_Boli"] +
            flow_numbers_dict["SAL_New_Boli"],
          percentage: "",
          color: "#2e4756",
          shift_x: -200,
          "stroke-width": 0.3333,
          border_color: "#2e4756",
        },
      ],
      links: [
        //Ebene 1:
        {
          source: "Leads",
          target: "Lost Leads",
          value:
            flow_numbers_dict["EVT_Lost_Leads"] +
            flow_numbers_dict["ORG_Lost_Leads"] +
            flow_numbers_dict["ADV_Lost_Leads"] +
            flow_numbers_dict["SAL_Lost_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },

        {
          source: "Leads",
          target: "Archived Leads",
          value:
            flow_numbers_dict["EVT_Archived_Leads"] +
            flow_numbers_dict["ORG_Archived_Leads"] +
            flow_numbers_dict["ADV_Archived_Leads"] +
            flow_numbers_dict["SAL_Archived_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },

        {
          source: "Leads",
          target: "Open Leads",
          value:
            flow_numbers_dict["EVT_Open_Leads"] +
            flow_numbers_dict["ORG_Open_Leads"] +
            flow_numbers_dict["ADV_Open_Leads"] +
            flow_numbers_dict["SAL_Open_Leads"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },

        {
          source: "Leads",
          target: "OPP",
          value:
            flow_numbers_dict["EVT_New_OPP"] +
            flow_numbers_dict["ORG_New_OPP"] +
            flow_numbers_dict["ADV_New_OPP"] +
            flow_numbers_dict["SAL_New_OPP"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },

        //Ebene 2:
        {
          source: "OPP",
          target: "Open",
          value:
            flow_numbers_dict["EVT_New_OPP_Open"] +
            flow_numbers_dict["ORG_New_OPP_Open"] +
            flow_numbers_dict["ADV_New_OPP_Open"] +
            flow_numbers_dict["SAL_New_OPP_Open"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },

        {
          source: "OPP",
          target: "Lost",
          value:
            flow_numbers_dict["EVT_New_OPP_Lost"] +
            flow_numbers_dict["ORG_New_OPP_Lost"] +
            flow_numbers_dict["ADV_New_OPP_Lost"] +
            flow_numbers_dict["SAL_New_OPP_Lost"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },

        {
          source: "OPP",
          target: "Archived",
          value:
            flow_numbers_dict["EVT_New_OPP_Archived"] +
            flow_numbers_dict["ORG_New_OPP_Archived"] +
            flow_numbers_dict["ADV_New_OPP_Archived"] +
            flow_numbers_dict["SAL_New_OPP_Archived"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },

        {
          source: "OPP",
          target: "New CUST",
          value:
            flow_numbers_dict["EVT_New_Customer"] +
            flow_numbers_dict["ORG_New_Customer"] +
            flow_numbers_dict["ADV_New_Customer"] +
            flow_numbers_dict["SAL_New_Customer"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },
        {
          source: "New CUST",
          target: "New Boli",
          value:
            flow_numbers_dict["EVT_New_Customer"] +
            flow_numbers_dict["ORG_New_Customer"] +
            flow_numbers_dict["ADV_New_Customer"] +
            flow_numbers_dict["SAL_New_Customer"],
          show_link: true,
          show_link_text: false,
          color: "#a7acc3",
        },
      ],
    };
  }

  export function power_chart_to_excel(power_chart_table, power_chart_column_names, title) {
    var obj = {
      months: [],
      names: [],
      values: {},
      title: title,
    };

    power_chart_table.forEach((element) => {
      var month = element["year_month"];

      month = month.replace("<b>", "");
      month = month.replace("</b>", "");
      month = month.replace("&#11088", "");

      obj["months"].push(month);
    });

    Object.keys(power_chart_table[0]).forEach((key) => {
      obj["names"].push(key);
      obj["values"][key] = [];
    });

    power_chart_table.forEach((element) => {
      Object.keys(element).forEach((key) => {
        var val = element[key].toString();

        val = val.replace("<b>", "");
        val = val.replace("</b>", "");
        val = val.replace("&#11088", "");

        obj["values"][key].push(val);
      });
    });

    console.log("############: obj: ", obj);

    return obj;
  }

  /**
   * add 0 in front of month number
   */
  export function nuller_einfuegen_und_to_string(zahl) {
    if (zahl >= 10) {
      return zahl.toString();
    }
    return "0" + zahl.toString();
  }

  export function komma_statt_punkt(val) {
    if (val) {
      return val.replace(".", ",");
    } else {
      return val;
    }
  }

  export function nFormatter(num, digits = 1) {
    return komma_statt_punkt(nFormatter_org(num, digits));
  }

  export function nFormatter_org(num, digits = 1) {
    // console.log("num: ", num)
    if (typeof num != "number") {
      // console.log("typeof(num) ", typeof(num))
      return num;
    }

    const lookup = [
      { value: 1, symbol: "" },
      { value: 1e3, symbol: "k" },
      { value: 1e6, symbol: "m" },
      { value: 1e9, symbol: "G" },
      { value: 1e12, symbol: "T" },
      { value: 1e15, symbol: "P" },
      { value: 1e18, symbol: "E" },
    ];
    const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
    var item = lookup
      .slice()
      .reverse()
      .find(function (item) {
        return num >= item.value;
      });
    return item ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol : "0";
  }

  export function get_date_text_table_from_selected_time_frame(date_start, date_end) {
    var today = new Date();
    var current_year = today.getFullYear();
    var current_month = today.getMonth();
    var current_day = today.getDate();

    var selected_end_year = date_end.getFullYear();
    var selected_end_month = date_end.getMonth();
    var selected_end_day = date_end.getDate();

    var selected_start_year = date_start.getFullYear();
    var selected_start_month = date_start.getMonth();
    var selected_start_day = date_start.getDate();

    // get year
    var selected_year = date_start.getFullYear();

    if (selected_start_month != selected_end_month && !(selected_start_year != selected_end_year)) {
      return (
        nuller_einfuegen_und_to_string(selected_start_month + 1) +
        "-" +
        nuller_einfuegen_und_to_string(selected_end_month + 1) +
        "/" +
        selected_end_year.toString()
      );
    } else if (selected_start_year != selected_end_year) {
      return (
        nuller_einfuegen_und_to_string(selected_start_month + 1) +
        "/" +
        selected_start_year.toString() +
        "-" +
        nuller_einfuegen_und_to_string(selected_end_month + 1) +
        "/" +
        selected_end_year.toString()
      );
    } else {
      return selected_start_month + 1 + "/" + selected_end_year.toString();
    }
  }

  export function get_date_text_from_selected_time_frame(date_start, date_end) {
    var today = new Date();
    var current_year = today.getFullYear();
    var current_month = today.getMonth();
    var current_day = today.getDate();

    var selected_end_year = date_end.getFullYear();
    var selected_end_month = date_end.getMonth();
    var selected_end_day = date_end.getDate();

    var selected_start_year = date_start.getFullYear();
    var selected_start_month = date_start.getMonth();
    var selected_start_day = date_start.getDate();

    // get year
    var selected_year = date_start.getFullYear();

    //check if YTD
    if (
      current_year == selected_end_year &&
      current_month == selected_end_month &&
      current_day == selected_end_day &&
      selected_start_year == current_year &&
      selected_start_month == 0 &&
      selected_start_day == 1
    ) {
      return "YTD " + selected_end_year.toString();
    }

    // get single month
    if (selected_start_year == selected_end_year && selected_start_month == selected_end_month) {
      return selected_end_year + " (" + month_array_short[selected_start_month] + ")";
    }

    // get 2 months

    return (
      " (" +
      month_array_short[selected_start_month] +
      " " +
      selected_start_year +
      " - " +
      month_array_short[selected_end_month] +
      " " +
      selected_end_year +
      ")"
    );
  }

  export function date_string_to_date_objects(date_list) {
    let date_list_obj = [];
    date_list.forEach((element) => {
      var date_obj = new Date(element);
      date_list_obj.push(date_obj);
    });
    return date_list_obj;
  }

  function sumPositiveRealNumbers(numbers) {
    let sum = 0;
    for (let i = 0; i < numbers.length; i++) {
      if (typeof numbers[i] === "number" && numbers[i] > 0) {
        sum += numbers[i];
      } else {
        return undefined;
      }
    }
    return sum;
  }

  function one_quaterly_value(dividend, divisor_1, divisor_2, divisor_3) {
    var sum = sumPositiveRealNumbers([divisor_1, divisor_2, divisor_3]);

    if (typeof sum === "number" && sum > 0) {
      return dividend / sum;
    }

    return undefined;
  }

  function one_bianual_value(dividend, divisor_1, divisor_2, divisor_3, divisor_4, divisor_5, divisor_6) {
    var sum = sumPositiveRealNumbers([divisor_1, divisor_2, divisor_3, divisor_4, divisor_5, divisor_6]);

    if (typeof sum === "number" && sum > 0) {
      return dividend / sum;
    }

    return undefined;
  }

  export function get_bianual_data(cac_quaterly_cost, new_boli_new_customers, months) {
    var current_month_key = get_year_month_key(new Date());

    var bi_1 = one_bianual_value(
      cac_quaterly_cost,
      new_boli_new_customers[months[0]],
      new_boli_new_customers[months[1]],
      new_boli_new_customers[months[2]],
      new_boli_new_customers[months[3]],
      new_boli_new_customers[months[4]],
      new_boli_new_customers[months[5]]
    );

    var bi_1_months = [months[0], months[1], months[2], months[3], months[4], months[5]];

    if (bi_1_months.includes(current_month_key)) {
      bi_1 = undefined;
    }

    var bi_2 = one_bianual_value(
      cac_quaterly_cost,
      new_boli_new_customers[months[6]],
      new_boli_new_customers[months[7]],
      new_boli_new_customers[months[8]],
      new_boli_new_customers[months[9]],
      new_boli_new_customers[months[10]],
      new_boli_new_customers[months[11]]
    );

    var bi_2_months = [months[6], months[7], months[8], months[9], months[10], months[11]];

    if (bi_2_months.includes(current_month_key)) {
      bi_2 = undefined;
    }

    return [bi_1, bi_2];
  }

  export function get_quaterly_data(cac_quaterly_cost, new_boli_new_customers, months) {
    var current_month_key = get_year_month_key(new Date());

    var qu_1 = one_quaterly_value(
      cac_quaterly_cost,
      new_boli_new_customers[months[0]],
      new_boli_new_customers[months[1]],
      new_boli_new_customers[months[2]]
    );
    var qu_1_months = [months[0], months[1], months[2]];
    if (qu_1_months.includes(current_month_key)) {
      qu_1 = undefined;
    }

    var qu_2 = one_quaterly_value(
      cac_quaterly_cost,
      new_boli_new_customers[months[3]],
      new_boli_new_customers[months[4]],
      new_boli_new_customers[months[5]]
    );
    var qu_2_months = [months[3], months[4], months[5]];
    if (qu_2_months.includes(current_month_key)) {
      qu_2 = undefined;
    }

    var qu_3 = one_quaterly_value(
      cac_quaterly_cost,
      new_boli_new_customers[months[6]],
      new_boli_new_customers[months[7]],
      new_boli_new_customers[months[8]]
    );
    var qu_3_months = [months[6], months[7], months[8]];
    if (qu_3_months.includes(current_month_key)) {
      qu_3 = undefined;
    }

    var qu_4 = one_quaterly_value(
      cac_quaterly_cost,
      new_boli_new_customers[months[9]],
      new_boli_new_customers[months[10]],
      new_boli_new_customers[months[11]]
    );
    var qu_4_months = [months[9], months[10], months[11]];
    if (qu_4_months.includes(current_month_key)) {
      qu_4 = undefined;
    }

    return [qu_1, qu_2, qu_3, qu_4];
  }

  export function percentage_math(a, b) {
    if (a == 0) {
      return 0;
    }

    if (b == 0) {
      return 100;
    }

    return (a * 100) / b;
  }

  export function get_difference_in_days(date1, date2, debug = false) {
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.round(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
  }

  export function date_objects_to_months(date_obj_list) {
    let month_list_obj = [];
    date_obj_list.forEach((element) => {
      var month_int = element.getMonth();
      month_list_obj.push(month_array_short[month_int]);
    });
    return month_list_obj;
  }

  export function date_objects_to_months_with_year(date_obj_list) {
    let month_list_obj = [];
    date_obj_list.forEach((element) => {
      var month_int = element.getMonth();
      var year_int = element.getFullYear();
      month_list_obj.push(month_array_short[month_int] + " " + year_int.toString());
    });
    return month_list_obj;
  }

  export function dict_to_list(data) {
    let keys = [];
    let values = [];

    for (const [key, value] of Object.entries(data)) {
      keys.push(key);
      values.push(value);
    }

    return { keys: keys, values: values };
    // body...
  }

  export function get_single_column(data, column_name) {
    let list = [];
    data.forEach((element) => {
      list.push(element[column_name]);
    });
    return list;
  }

  export function filter_dataset_according_exists_in_array(data, column_name, array) {
    let list = [];
    data.forEach((element) => {
      if (element[column_name]) {
        if (array.includes(element[column_name])) {
          list.push(element);
        }
      }
    });
    return list;
  }

  export function filter_dataset_according_dictentry_exists_in_array(data, column_name, array, withoutindex = false) {
    let list = [];
    console.log("column_name: ", column_name);
    data.forEach((element) => {
      if (element[column_name]) {
        if (!withoutindex) {
          if (array.includes(element[column_name][1])) {
            list.push(element);
          }
        } else {
          if (array.includes(element[column_name])) {
            list.push(element);
          }
        }
      }
    });

    return list;
  }

  export function filter_dates(data, selected_from, selected_to, column_name) {
    let list = [];
    let selected_from_obj = new Date(selected_from);
    let selected_to_obj = new Date(selected_to);

    data.forEach((element) => {
      let date = new Date(element[column_name]);
      if (date > selected_from_obj && date < selected_to_obj) {
        list.push(element);
      }
    });

    return list;
  }

  export function hasDuplicates(array) {
    return new Set(array).size !== array.length;
  }

  export function date_list_to_month_index_list(datelist) {
    var index_list = [];

    datelist.forEach((element) => {
      index_list.push(date_to_month_index_correct(element));
    });

    return index_list;
  }

  export function date_to_month_index(date) {
    if (date.getMonth() < 10) {
      return date.getFullYear().toString() + "-0" + date.getMonth().toString();
    } else {
      return date.getFullYear().toString() + "-" + date.getMonth().toString();
    }
  }

  export function getMonthDifference(startDate, endDate) {
    return endDate.getMonth() - startDate.getMonth() + 12 * (endDate.getFullYear() - startDate.getFullYear());
  }

  export function date_to_month_index_correct(date) {
    let month = date.getMonth() + 1;
    if (month < 10) {
      return date.getFullYear().toString() + "-0" + month.toString();
    } else {
      return date.getFullYear().toString() + "-" + month.toString();
    }
  }

  export function get_three_previous_months() {
    let return_list = [];

    var x = new Date();
    x.setDate(1);
    return_list.push(date_to_month_index(x));
    x.setMonth(x.getMonth() - 1);
    return_list.push(date_to_month_index(x));
    x.setMonth(x.getMonth() - 1);
    return_list.push(date_to_month_index(x));

    return return_list;
  }

  export function get_three_previous_months_date() {
    let return_list = [];

    var x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth());

    // console.log('x: ', x);

    return_list.push(x);
    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 1);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 2);
    return_list.push(x);

    // console.log('return_list: ', return_list);

    return return_list;
  }

  export function sleep(milliseconds) {
    return new Promise((resolve) => setTimeout(resolve, milliseconds));
  }

  export function divide_by(data, column_name, index) {
    let return_dict = {};

    data.forEach((element) => {
      return_dict[element[column_name][index]] = [];
    });

    data.forEach((element) => {
      return_dict[element[column_name][index]].push(element);
    });

    return return_dict;
  }

  export function auffuellen(string) {
    if (!string) {
      return "";
    }

    string = string.toString();

    while (string.length < 10) {
      string = " " + string;
    }

    return string;
  }

  export function get_twelfe_previous_months_index_names(months_date_objs) {
    let month_list = [];

    months_date_objs.forEach((element) => {
      month_list.push(date_objects_to_months_with_year([element]));
    });

    return month_list;
  }

  export function get_twelfe_previous_months_date() {
    let return_list = [];

    var x = new Date();

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 0);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 1);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 2);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 3);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 4);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 5);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 6);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 7);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 8);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 9);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 10);
    return_list.push(x);

    x = new Date();
    x.setDate(1);
    x.setMonth(x.getMonth() - 11);
    return_list.push(x);

    // console.log('return_list: ', return_list);

    return return_list;
  }

  export function get_current_month_multiplicator() {
    var current_year = new Date().getFullYear().toString();
    var current_month_int = new Date().getMonth() + 1;
    var current_day_in_month = new Date().getDate();
    var days_in_month = new Date(current_year, current_month_int, 0).getDate();

    return current_day_in_month / days_in_month;
  }

  export function get_year_month_key(date) {
    let month_index;
    if (date.getMonth() + 1 < 10) {
      month_index = date.getFullYear().toString() + "-0" + (date.getMonth() + 1).toString();
    } else {
      month_index = date.getFullYear().toString() + "-" + (date.getMonth() + 1).toString();
    }

    return month_index;
  }

  export function month_index_list_to_name_list(data) {
    let return_list = [];

    data.forEach((element) => {
      // console.log('date_to_month_index(element): ', element.getMonth());
      return_list.push(month_array_long[element.getMonth()]);
    });

    return return_list;
  }

  export function calc_boli_reorder_and_new(month_array, data) {
    let ret_dict_reorder = {};
    let ret_dict_new = {};

    month_array.forEach((m) => {
      ret_dict_reorder[m] = 0;
      ret_dict_new[m] = 0;
    });

    let order_types = {};

    data.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      let year_month = "";

      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }
      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }

      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("smaxtec")) {
          return;
        }
      }
      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("Smaxtec")) {
          return;
        }
      }

      if (element["x_studio_product_category"] != "Sales Product / Classic Bolus") {
        return;
      }

      if (element["order_type"] == "Reorder" || element["x_studio_order_type"] == "Reorder") {
        ret_dict_reorder[year_month] = ret_dict_reorder[year_month] + element["product_uom_qty"];
      } else {
        if (!element["x_studio_order_type"]) {
          ret_dict_new[year_month] = ret_dict_new[year_month] + element["product_uom_qty"];
        }
      }
    });

    return { new: ret_dict_new, reorder: ret_dict_reorder };
  }

  export function two_lists_to_dict(list_1, list_2) {
    let ret_dict = {};

    var index = 0;
    list_1.forEach((l1) => {
      ret_dict[l1] = list_2[index];
      index += 1;
    });

    return ret_dict;
  }

  export function calc_boli_sales_warranty_goodwill_old_field(month_array, data) {
    let ret_dict = {};

    month_array.forEach((m) => {
      ret_dict[m] = 0;
    });

    let order_types = {};

    data.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      let year_month = "";
      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }
      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }

      var old_order_type = element["x_studio_order_type"];
      var new_order_type = element["order_type"];

      if (new_order_type) {
        return;
      }

      if (old_order_type != "Warranty / Goodwill") {
        return;
      }

      if (element["price_total"] != 0) {
        return;
      }

      if (element["x_studio_product_category"] != "Sales Product / Classic Bolus") {
        return;
      }

      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("smaxtec")) {
          return;
        }
      }
      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("Smaxtec")) {
          return;
        }
      }

      ret_dict[year_month] = ret_dict[year_month] + element["product_uom_qty"];
    });

    return ret_dict;
  }

  export function calc_boli_sales_price_null_per_month(month_array, data) {
    let ret_dict = {};

    month_array.forEach((m) => {
      ret_dict[m] = 0;
    });

    let order_types = {};

    data.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      let year_month = "";
      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }
      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }

      if (element["price_total"] != 0) {
        return;
      }

      if (element["x_studio_product_category"] != "Sales Product / Classic Bolus") {
        return;
      }

      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("smaxtec")) {
          return;
        }
      }
      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("Smaxtec")) {
          return;
        }
      }

      ret_dict[year_month] = ret_dict[year_month] + element["product_uom_qty"];
    });

    return ret_dict;
  }

  export function calc_boli_order_type_per_month(month_array, data, order_type, order_type_field = "order_type") {
    let ret_dict = {};

    month_array.forEach((m) => {
      ret_dict[m] = 0;
    });

    let order_types = {};

    data.forEach((val) => {
      var element = 1 in val ? val[1] : val;

      let year_month = "";
      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }
      if (element["x_studio_order_date_mw"]) {
        year_month = element["x_studio_order_date_mw"].substring(0, 7);
      }

      let order_type_obj = element[order_type_field];

      if (!(order_type_obj.toString() in order_types)) {
        order_types[order_type_obj.toString()] = 1;
      } else {
        order_types[order_type_obj.toString()] += 1;
      }

      // console.log("order_type_obj: ", order_type_obj)

      if (!order_type_obj) {
        return;
      }

      if (order_type_obj.toLowerCase() != order_type.toLowerCase()) {
        return;
      }

      if (element["price_total"] != 0) {
        return;
      }

      if (element["x_studio_product_category"] != "Sales Product / Classic Bolus") {
        return;
      }

      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("smaxtec")) {
          return;
        }
      }
      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("Smaxtec")) {
          return;
        }
      }

      ret_dict[year_month] = ret_dict[year_month] + element["product_uom_qty"];
    });

    return ret_dict;
  }

  export function calc_boli_price_null_per_month(month_array, data) {
    let ret_dict = {};

    month_array.forEach((m) => {
      ret_dict[m] = 0;
    });

    data.forEach((element) => {
      let year_month = element["x_studio_order_date_mw"].substring(0, 7);

      if (element["price_total"] != 0) {
        return;
      }

      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("smaxtec")) {
          return;
        }
      }
      if (element["partner"]) {
        if (element["partner"][1].toLowerCase().includes("Smaxtec")) {
          return;
        }
      }

      ret_dict[year_month] = ret_dict[year_month] + element["product__amount"];
    });

    return ret_dict;
  }

  export function check_x_team_country_entry_does_entry_belong_to_team(
    debug,
    sales_person,
    salesman_selected,
    x_team_country_dashboard,
    country,
    selected_team,
    create_date = false,
    consider_date = false
  ) {
    var found_special_entry;
    var return_value;
    var country_list = countries_by_salesteam.hasOwnProperty(selected_team) ? countries_by_salesteam[selected_team] : [];

    x_team_country_dashboard.forEach((x) => {
      var x_sales_person = x["x_salesperson_dashboard"][1];
      var x_country = x["x_country_dashboard"][1];
      var x_team = x["x_salesteam_dashboard"][1];
      var x_old_team = x["x_studio_previous_sales_team"][1];

      if (x_sales_person != sales_person) {
        return;
      }

      if (selected_team == "ALL") {
        return;
      }

      if (selected_team != x_team && selected_team != x_old_team) {
        return;
      }

      if (selected_team == x_team && !salesman_selected.includes(x_sales_person)) {
        return;
      }
      // if (debug == true) {
      // console.log(sales_person);
      // console.log('salesman_selected: ', salesman_selected);
      // }

      found_special_entry = true;
      return_value = false;

      if (!consider_date) {
        if (country) {
          if (country == x_country) {
            if (x_team == selected_team) {
              found_special_entry = true;
              return_value = true;
            } else {
              found_special_entry = true;
              return_value = false;
            }
          }
          if (country != x_country) {
            if (x_team == selected_team) {
              found_special_entry = true;
              return_value = false;
            } else {
              found_special_entry = true;
              return_value = true;
            }
          }
        }
      }

      if (consider_date) {
        if (date_in_between_dates(create_date, x["x_changeteam_date"], "x_studio_end_date")) {
          if (selected_team == x_team) {
            found_special_entry = true;
            return_value = true;
            // console.log("1 selected team gleich team")
          } else {
            found_special_entry = true;
            return_value = false;
            console.log("1 selected team UNgleich team");
          }
        } else {
          if (selected_team != x_team) {
            found_special_entry = true;
            return_value = true;
            // console.log("2 selected team gleich team")
          } else {
            found_special_entry = true;
            return_value = false;
            console.log("2 selected team UNgleich team");
          }
        }
      }
    });

    if (found_special_entry) {
      return return_value;
    }

    // console.log('salesman_selected', salesman_selected);
    if (salesman_selected.includes(sales_person)) {
      // if(sales_person == "Aisling Downey"){
      // console.log('True Country: ', country);
      // }
      // exclude sales from smX HQ and others if the country not in the sales team country list
      if (!country_list.includes(country) && country) {
        if (selected_team != "smX HQ" && selected_team != "ALL") {
          return false;
        }
      }

      return true;
    } else {
      // if(sales_person == "Aisling Downey"){
      //   console.log("False Country: ", country)
      // }
      return false;
    }
  }

  function date_in_between_dates(date, start, end) {
    var date_obj = new Date(date);
    var start_obj = new Date(start);
    var end_obj = new Date(end);

    // if(date == "2022-03-01"){
    //   console.log("date_obj: ", date_obj)
    //   console.log("start_obj: ", start_obj)
    //   console.log("end_obj: ", end_obj)
    // }

    if (date_obj < start_obj) {
      // console.log("DATE KLEINER?")
      return false;
    }

    if (end && date_obj < end_obj) {
      // console.log("DAS")
      return true;
    }

    // console.log("DAS2")
    return true;
  }

  export function format_name(fullname) {
    let formatted_name = fullname.split(" ");
    formatted_name = formatted_name.map((name) => {
      return name.charAt(0).toUpperCase() + name.substring(1).toLowerCase();
    });
    formatted_name = formatted_name.join(" ");
    return formatted_name;
  }
</script>
